export enum USER_SURVEY_STATUS {
    PENDING = 'PENDING',
    STARTED = 'STARTED',
    COMPLETED = 'COMPLETED',
    DISMISSED = 'DISMISSED',
}
